export const euro = (cents: number) =>
  (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });

export const dateTime = (epoch: number | null | undefined) =>
  epoch
    ? new Date(epoch).toLocaleString('de-DE', {
        timeZone: 'Europe/Berlin',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '–';

export const percent = (vatRate: string) => `${String(Number(vatRate)).replace('.', ',')} %`;

export const calendarDate = (isoDate: string) => isoDate.split('T')[0].split('-').reverse().join('.');
